import React, { useEffect } from 'react';
import useQuestVideoWatchdog from '../../hooks/useQuestVideoWatchdog';
import { buildAgentName } from './OxGreetingScreen';
import professorCharacter from '../../assets/quest/fp_greet_char.webp';
import './PictureQuizRunner.css';

const STATIC_GREETING_MS = 3500;

export default function PictureQuizGreetingScreen({
  videoUrl, memberNickname, onFinished, onAbort,
}) {
  const { videoRef, videoPlaying, isVideoPhase, videoHandlers } = useQuestVideoWatchdog({
    active: Boolean(videoUrl),
    videoUrl,
    onFinished,
    onAbort,
    logLabel: '그림 퀴즈 인사 영상',
  });

  useEffect(() => {
    if (videoUrl) return undefined;
    const timerId = window.setTimeout(() => onFinished?.(), STATIC_GREETING_MS);
    return () => window.clearTimeout(timerId);
  }, [onFinished, videoUrl]);

  return (
    <section className="picture-quiz-greeting" data-testid="picture-quiz-greeting">
      {isVideoPhase && (
        <video
          ref={videoRef}
          className={`picture-quiz-greeting__timeline${videoPlaying ? ' is-playing' : ''}`}
          src={videoUrl}
          autoPlay
          muted
          playsInline
          preload="auto"
          aria-label="그림 퀴즈 인사 화면 전환 영상"
          {...videoHandlers}
        />
      )}
      <img
        className="picture-quiz-greeting__professor"
        src={professorCharacter}
        alt="그림 퀴즈를 안내하는 요원"
        draggable="false"
      />
      <span className="picture-quiz-greeting__bubble" aria-hidden="true" />
      <p className="picture-quiz-greeting__name">
        {buildAgentName(memberNickname)}
      </p>
      <div className="picture-quiz-greeting__lines">
        <p>그림퀴즈를</p>
        <p>낼 거야.</p>
        <p>잘 맞춰봐!</p>
      </div>
    </section>
  );
}
